var enums = {
    hostingEnvironmentType : [
        { index: 0, value: "Empty", title: "Geen" },
        { index: 1, value: "Test", title: "Test" },
        { index: 2, value: "Acceptance", title: "Acceptatie" },
        { index: 3, value: "Production", title: "Live" }
    ],

    profitEnvironmentType : [
        { index: 0, value: "External", title: "Extern" },
        { index: 1, value: "Internal", title: "Intern" }
    ],

    loginType: [
        { index: 0, value: "None", title: "Geen" },
        { index: 1, value: "Adfs", title: "Adfs" },
        { index: 2, value: "AzureAD", title: "AzureAD" },
        { index: 3, value: "Google", title: "Google" },
    ],

    rapLocation: [
        { index: 0, value: "MyRap", title: "Mijn RAP"},
        { index: 1, value: "RapHrm", title: "RAP Hrm"},
        { index: 2, value: "Both", title: "Beide"},
    ],

    wageComponentStatus: [
        { index: 0, value: "New", title: "Nieuw" },
        { index: 1, value: "Edited", title: "Gewijzigd" },
        { index: 2, value: "Verified", title: "Gecontroleerd" },
        { index: 3, value: "Failed", title: "Fout" }
    ],

    wageComponentProgressStatus: [
        { index: 0, value: "None", title: "Geen" },
        { index: 1, value: "Open", title: "Open" },
        { index: 2, value: "InProgress", title: "Onder controle" },
        { index: 3, value: "InformationRequested", title: "Vraag uitgezet" },
        { index: 4, value: "OnHold", title: "On hold" }
    ],

    region: [
        { index: 0, value: "All", title: "Alle" },
        { index: 1, value: "North", title: "Noord" },
        { index: 2, value: "Central", title: "Midden" },
        { index: 3, value: "South", title: "Zuid" }
    ],

    pageTarget: [
        { index: 0, value: "Current", title: "Huidig tabblad" },
        { index: 1, value: "New", title: "Nieuw tabblad" },
    ],

    shortcutType: [
        { index: 0, value: "SearchTerm", title: "Zoekopdracht" },
        { index: 1, value: "Article", title: "Artikel" },
    ],

    checkCategoryType: [
        { index: 0, value: "None", title: "Geen" },
        { index: 1, value: "Month", title: "Maandelijks" },
        { index: 2, value: "Startup", title: "Opstart" },
        { index: 3, value: "Closure", title: "Einde" }
    ]
}
